import {
  Document,
  Paragraph,
  TextRun,
  ImageRun,
  Header,
  LevelFormat,
} from "docx";
import marketview_logo from "assets/images/marketview_logo_w_icon_blue.png";
import {
  getUniqueFunds,
  createNeedRankTable,
  createSpecialFundsList,
  getCurrentDate,
} from "./helpers/export-util";
import { createCoaTable } from "./helpers/export-coa-helper";
import { createNonModeledDataTable } from "./helpers/export-model-results-helper";
import { createMatrixTable } from "./helpers/export-regime-helper";
export const createDocument = async ({
  costOfAttendance,
  xdimensions,
  matrices,
  ydimensions,
  firstYearEstimate,
  modelResults,
  nonModeledData,
  specialFunds,
}) => {
  const uniqueFunds = getUniqueFunds(specialFunds);

  try {
    const mv_logo = await fetch(marketview_logo);
    const blob = await mv_logo.blob();

    const mv_image = new ImageRun({
      data: blob,
      type: "png",
      transformation: {
        width: 200,
        height: 50,
      },
    });

    const date = getCurrentDate();

    // Create tables using helper functions
    const coa_table = createCoaTable(costOfAttendance);

    const needRankTable =
      xdimensions && xdimensions.length > 0
        ? createNeedRankTable(xdimensions)
        : null;

    const matrixTable =
      matrices && matrices.length > 0 && xdimensions && ydimensions
        ? createMatrixTable(matrices, xdimensions, ydimensions)
        : null;

    const specialFundsList = createSpecialFundsList(uniqueFunds);

    const modelResultsTable = createNonModeledDataTable(
      modelResults,
      firstYearEstimate,
      nonModeledData
    );

    const doc = new Document({
      numbering: {
        config: [
          {
            reference: "my-numbering",
            levels: [
              {
                level: 0,
                format: LevelFormat.DECIMAL,
                text: "%1.",
              },
            ],
          },
        ],
      },
      sections: [
        {
          properties: {
            titlePage: true,
          },
          headers: {
            first: new Header({
              children: [
                new Paragraph({
                  children: [mv_image],
                }),
              ],
            }),
          },
          children: [
            new Paragraph(""),
            new Paragraph(""),
            new Paragraph("\nTo:"),
            new Paragraph("\nFrom:"),
            new Paragraph("\nDate: " + date),
            new Paragraph("\nRE: 2025-2026 Packaging Policy"),
            new Paragraph("\n"),
            new Paragraph({
              children: [
                new TextRun({
                  text: "\nAid Applicants and Need Ranks",
                  bold: true,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: "2025-2026 Estimated Costs (Resident)",
                  italics: true,
                }),
              ],
              numbering: {
                reference: "my-numbering",
                level: 0,
              },
            }),
            coa_table,
            new Paragraph("\n"),
            ...(needRankTable
              ? [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Financial Need Rank Calculation",
                        italics: true,
                      }),
                    ],
                    numbering: {
                      reference: "my-numbering",
                      level: 0,
                    },
                  }),
                  needRankTable,
                ]
              : []),
            new Paragraph("\n"),
            new Paragraph({
              children: [
                new TextRun({
                  text: "\nNeed and Merit Target Matrix",
                  bold: true,
                }),
              ],
            }),
            ...(matrixTable
              ? [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Need Rank x Academic Rank",
                        italics: true,
                      }),
                    ],
                    numbering: {
                      reference: "my-numbering",
                      level: 0,
                    },
                  }),
                  matrixTable,
                ]
              : []),
            new Paragraph("\n"),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Special Funds",
                  bold: true,
                }),
              ],
            }),
            ...specialFundsList,
            new Paragraph("\n"),
            new Paragraph("\n"),
            new Paragraph({
              children: [
                new TextRun({
                  text: "Model Results",
                  bold: true,
                }),
              ],
            }),
            modelResultsTable,
          ],
        },
      ],
    });

    console.log("Document created successfully");
    return doc;
  } catch (error) {
    console.error("Error in createDocument:", error);
    throw error;
  }
};
